/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionPlanDetailsDto } from './SubscriptionPlanDetailsDto';
import {
    SubscriptionPlanDetailsDtoFromJSON,
    SubscriptionPlanDetailsDtoFromJSONTyped,
    SubscriptionPlanDetailsDtoToJSON,
    SubscriptionPlanDetailsDtoToJSONTyped,
} from './SubscriptionPlanDetailsDto';

/**
 * 
 * @export
 * @interface GetAssignableSubscriptionPlansDto
 */
export interface GetAssignableSubscriptionPlansDto {
    /**
     * 
     * @type {Array<SubscriptionPlanDetailsDto>}
     * @memberof GetAssignableSubscriptionPlansDto
     */
    items: Array<SubscriptionPlanDetailsDto>;
}

/**
 * Check if a given object implements the GetAssignableSubscriptionPlansDto interface.
 */
export function instanceOfGetAssignableSubscriptionPlansDto(value: object): value is GetAssignableSubscriptionPlansDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetAssignableSubscriptionPlansDtoFromJSON(json: any): GetAssignableSubscriptionPlansDto {
    return GetAssignableSubscriptionPlansDtoFromJSONTyped(json, false);
}

export function GetAssignableSubscriptionPlansDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAssignableSubscriptionPlansDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(SubscriptionPlanDetailsDtoFromJSON)),
    };
}

export function GetAssignableSubscriptionPlansDtoToJSON(json: any): GetAssignableSubscriptionPlansDto {
    return GetAssignableSubscriptionPlansDtoToJSONTyped(json, false);
}

export function GetAssignableSubscriptionPlansDtoToJSONTyped(value?: GetAssignableSubscriptionPlansDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(SubscriptionPlanDetailsDtoToJSON)),
    };
}

